import { captureException, captureMessage } from "@sentry/react"
import axios from "axios"
import storeClient from "../../storeClient"
// import storeServer from "../../storeServer"

const clientMap = new Map();

const { RAZZLE_API_MARCA_BLANCA } = process.env

// if (typeof window === "undefined") {
//   store = storeServer
// } else {
//   store = storeClient
// }

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
}

const addRequestInterceptors = (client, token) => {

  client.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
}

const cleanRequestInterceptors = (client) => {
  client.interceptors.request.handlers.forEach((_, index) => {
    client.interceptors.request.eject(index);
  });

}


function applyResponseInterceptors(client) {

  client.interceptors.response.use(
    (response) => {
      if (response && response.data) {
        return response.data.object ? response.data.object : response.data
      }

      captureMessage(
        "Error con Axios, no hay respuesta o en la respuesta no existe data o status"
      )
      return Promise.reject(response.data)
    },
    (error) => {
      captureException(error)
      return Promise.reject(error)
    }
  )
}

function createMethods(client) {
  return {
    get(path, params = {}) {
      return client.get(path, {
        headers,
        params,
      })
    },
    post(path, data = {}) {
      return client.post(path, data, { headers })
    },
  }
}

const createAxiosInstance = (baseURL, store) => {
  let client
  let applicationId
  let token
  if (!store) { 
    const sClient = storeClient 
    applicationId = sClient.getState().applicationState.applicationId
    token = sClient.getState().applicationState.token
  } 
  else {
    applicationId = store.applicationState.applicationId
    token = store.applicationState.token
  }
  
  
  if (clientMap.has(applicationId)) {
    client = clientMap.get(applicationId)
    cleanRequestInterceptors(client)
    addRequestInterceptors(client, token)
  } else {
    // Si no está en el mapa, crear uno nuevo
    client = axios.create({
      baseURL,
      headers,
    })

    applyResponseInterceptors(client)
    addRequestInterceptors(client, token)

    clientMap.set(applicationId, client)
  }

  return createMethods(client)

}


const createAxiosInstanceWithStore = (store) => {
  return createAxiosInstance(RAZZLE_API_MARCA_BLANCA, store)
}

const marcaBlancaApiClient = createAxiosInstance(RAZZLE_API_MARCA_BLANCA)

export { marcaBlancaApiClient, createAxiosInstanceWithStore }
